import * as tslib_1 from "tslib";
// Core packages
import { ElementRef, OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
// Third party packages
import { MatDialog } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { startWith, takeUntil, tap } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { PropertyDetailDocumentNoteDialogComponent } from "src/app/modules/properties/components/document-note-dialog/document-note-dialog.component";
import { PropertyDetailMappingNoteDialogComponent } from "src/app/modules/properties/components/mapping-note-dialog/mapping-note-dialog.component";
import { CondoStructuresService } from "src/app/modules/properties/condo-structures.service";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
var AdminQRCodeMappingComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function AdminQRCodeMappingComponent(configService, propertiesService, router, activatedRoute, toastrService, helperService, translateService, authService, cookieService, dialog, condoStructuresService, settingsService) {
        this.configService = configService;
        this.propertiesService = propertiesService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.toastrService = toastrService;
        this.helperService = helperService;
        this.translateService = translateService;
        this.authService = authService;
        this.cookieService = cookieService;
        this.dialog = dialog;
        this.condoStructuresService = condoStructuresService;
        this.settingsService = settingsService;
        this.subscriptions = [];
        this.onDestroy$ = new Subject();
        this.loggedUserToleType = "";
        this.loggedUserMaster = false;
        this.loggedUserAdmin = false;
        this.lang = 'it';
        // Could not be "Property" type because in "get" method in the back-end
        // We are populating some fields, so the model is not the same!
        this.cardIsLoading = true;
        this.mappingIndex = [];
        this.formIsLoading = false; // Used to view/hide form loading spinner
        // BEGIN - Formly config
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {
            formState: {
                disabled: false
            }
        };
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: true,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true
            }
        };
        this.existingNotes = [];
        this.enableFormModify = false;
        this.sectionPlant = false;
        this.remakePlant = false;
        this.remakePlantDocs = {};
        this.rimappatura = false;
        this.mappaturaOpen = false;
        this.showSideMenu = true;
        this.subscriptionType = 'FREE';
        this.condoStructureTemplateId = "";
        this.condoStructureTemplate = [];
        this.notesExist = false;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    AdminQRCodeMappingComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Subscribe to current lang and init component
        this.translateService.use("it");
        var structureId = this.activatedRoute.snapshot.params.structureId;
        if (structureId && structureId !== '') {
            this.condoStructuresService
                .getView(structureId)
                .subscribe(function (res) {
                var e_1, _a;
                if (res.status) {
                    _this.condoStructure = res.data;
                }
                else {
                    _this.toastrService.error(res.message);
                    _this.router.navigate([_this.lang, "errors", "404"]);
                }
                _this.subscriptions.push(_this.propertiesService.getView(_this.condoStructure.property).subscribe(function (res) {
                    if (res.status) {
                        // Set permission data
                        _this.property = res.data;
                        _this.onChanges();
                        return;
                    }
                    // Something bad happened
                    _this.router.navigate([_this.lang, "errors", "404"]);
                }, function (err) {
                    // if we came here users with given userId do not exist
                    _this.router.navigate([_this.lang, "errors", "404"]);
                }));
                for (var key in _this.condoStructure) {
                    if (Array.isArray(_this.condoStructure[key]) &&
                        _this.condoStructure[key].length) {
                        try {
                            for (var _b = (e_1 = void 0, tslib_1.__values(_this.condoStructure[key])), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var el = _c.value;
                                if (el.note && Array.isArray(el.note) && el.note.length) {
                                    _this.notesExist = true;
                                    break;
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        if (_this.notesExist) {
                            break;
                        }
                    }
                }
                _this.cardIsLoading = false;
            });
        }
        else {
            this.router.navigate([this.lang, "errors", "404"]);
        }
    };
    /**
     * Listen on input values changes
     *
     * @since 1.0.0
     */
    AdminQRCodeMappingComponent.prototype.onChanges = function () {
        var _this = this;
        // Update property
        if (this.property && this.property.currentValue && this.property.currentValue._id) {
            this.property = this.property.currentValue;
            this.propertyId = this.property.currentValue._id;
        }
        // Update form section depending on current mappingFormActiveSection
        if (this.property) {
            this.mappaturaOpen = this.condoStructure.open;
            if (this.condoStructure.rimappatura) {
                this.rimappatura = true;
            }
            if (this.mappingIndex.length === 0) {
                this.subscriptions.push(this.settingsService.getStructureView().subscribe(function (res) {
                    if (res.status) {
                        if (res.condoStructureTemplate &&
                            Array.isArray(res.condoStructureTemplate) &&
                            res.condoStructureTemplate.length > 0 &&
                            res.condoStructureTemplate[0].area &&
                            Array.isArray(res.condoStructureTemplate[0].area)) {
                            _this.condoStructureTemplateId = res.condoStructureTemplate[0]._id;
                            _this.condoStructureTemplate = res.condoStructureTemplate[0].area;
                            var structureTemplate = JSON.parse(JSON.stringify(_this.condoStructureTemplate));
                            // hide question deleted
                            _this.mappingIndex = structureTemplate.filter(function (el) {
                                if (!el.deleted) {
                                    if (el.content && Array.isArray(el.content)) {
                                        var content = el.content.filter(function (subEl) { return !subEl.deleted; });
                                        if (content && Array.isArray(content)) {
                                            content.forEach(function (subContent) {
                                                if (subContent &&
                                                    subContent.formConfig &&
                                                    Array.isArray(subContent.formConfig) &&
                                                    subContent.formConfig.length === 1 &&
                                                    subContent.formConfig[0].fieldGroup &&
                                                    Array.isArray(subContent.formConfig[0].fieldGroup)) {
                                                    var fieldGroup = subContent.formConfig[0].fieldGroup.filter(function (group) { return !group.deleted; });
                                                    subContent.formConfig[0].fieldGroup = fieldGroup;
                                                }
                                            });
                                        }
                                        el.content = content;
                                    }
                                    return true;
                                }
                            });
                            _this.mappingIndex = _this.translateKeys2(["placeholder", "label"], _this.mappingIndex);
                            _this.updateFormSection();
                            _this.cardIsLoading = false;
                            // Check property type: Condo or BSC
                            _this.subscriptionType = _this.property.subscription.key;
                            if (_this.property.type === "bsc") {
                                var strutture = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.strutture";
                                });
                                if (strutture
                                    && strutture.content
                                    && Array.isArray(strutture.content)) {
                                    var index = strutture.content.findIndex(function (item) {
                                        return item.key === "condominiBsc";
                                    });
                                    strutture.content[index].hidden = false;
                                    index = strutture.content.findIndex(function (item) {
                                        return item.key === "fabbricatoAbitativo";
                                    });
                                    strutture.content[index].hidden = true;
                                    index = strutture.content.findIndex(function (item) {
                                        return item.key === "struttureFabbindip";
                                    });
                                    strutture.content[index].hidden = false;
                                }
                                var trattamentoAcqua = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.trattamentoAcqua";
                                });
                                if (trattamentoAcqua
                                    && trattamentoAcqua.content
                                    && Array.isArray(trattamentoAcqua.content)) {
                                    var index = trattamentoAcqua.content.findIndex(function (item) {
                                        return item.key === "sottostazioneAltroCondBsc";
                                    });
                                    trattamentoAcqua.content[index].hidden = true;
                                }
                                var riscaldamentoCondizionamento = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.riscaldamentoCondizionamento";
                                });
                                if (riscaldamentoCondizionamento
                                    && riscaldamentoCondizionamento.content
                                    && Array.isArray(riscaldamentoCondizionamento.content)) {
                                    // let index = riscaldamentoCondizionamento.content.findIndex((item: any) => {
                                    //   return item.key === "sottostazioniCt"
                                    // });
                                    // riscaldamentoCondizionamento.content[index].hidden = true;
                                    // let index = riscaldamentoCondizionamento.content.findIndex((item: any) => {
                                    //   return item.key === "centraleRicervimento"
                                    // });
                                    // riscaldamentoCondizionamento.content[index].hidden = true;
                                    var index = riscaldamentoCondizionamento.content.findIndex(function (item) {
                                        return item.key === "cannaCollettiva";
                                    });
                                    riscaldamentoCondizionamento.content[index].hidden = true;
                                }
                                var dispositiviAntincendio = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.dispositiviAntincendio";
                                });
                                if (dispositiviAntincendio
                                    && dispositiviAntincendio.content
                                    && Array.isArray(dispositiviAntincendio.content)) {
                                    var index = dispositiviAntincendio.content.findIndex(function (item) {
                                        return item.key === "evac";
                                    });
                                    dispositiviAntincendio.content[index].hidden = true;
                                }
                            }
                            else {
                                var strutture = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.strutture";
                                });
                                if (strutture
                                    && strutture.content
                                    && Array.isArray(strutture.content)) {
                                    var index = strutture.content.findIndex(function (item) {
                                        return item.key === "condominiBsc";
                                    });
                                    strutture.content[index].hidden = true;
                                    index = strutture.content.findIndex(function (item) {
                                        return item.key === "fabbricatoAbitativo";
                                    });
                                    strutture.content[index].hidden = false;
                                    index = strutture.content.findIndex(function (item) {
                                        return item.key === "struttureFabbindip";
                                    });
                                    strutture.content[index].hidden = false;
                                }
                                var trattamentoAcqua = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.trattamentoAcqua";
                                });
                                if (trattamentoAcqua
                                    && trattamentoAcqua.content
                                    && Array.isArray(trattamentoAcqua.content)) {
                                    var index = trattamentoAcqua.content.findIndex(function (item) {
                                        return item.key === "sottostazioneAltroCondBsc";
                                    });
                                    trattamentoAcqua.content[index].hidden = false;
                                }
                                var riscaldamentoCondizionamento = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.riscaldamentoCondizionamento";
                                });
                                if (riscaldamentoCondizionamento
                                    && riscaldamentoCondizionamento.content
                                    && Array.isArray(riscaldamentoCondizionamento.content)) {
                                    // let index = riscaldamentoCondizionamento.content.findIndex((item: any) => {
                                    //   return item.key === "sottostazioniCt"
                                    // });
                                    // riscaldamentoCondizionamento.content[index].hidden = false;
                                    // let index = riscaldamentoCondizionamento.content.findIndex((item: any) => {
                                    //   return item.key === "centraleRicervimento"
                                    // });
                                    // riscaldamentoCondizionamento.content[index].hidden = false;
                                    var index = riscaldamentoCondizionamento.content.findIndex(function (item) {
                                        return item.key === "cannaCollettiva";
                                    });
                                    riscaldamentoCondizionamento.content[index].hidden = false;
                                }
                                var dispositiviAntincendio = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.dispositiviAntincendio";
                                });
                                if (dispositiviAntincendio
                                    && dispositiviAntincendio.content
                                    && Array.isArray(dispositiviAntincendio.content)) {
                                    var index = dispositiviAntincendio.content.findIndex(function (item) {
                                        return item.key === "evac";
                                    });
                                    dispositiviAntincendio.content[index].hidden = false;
                                }
                            }
                            _this.watchFormChanges();
                            _this.watchScaleChanges();
                            _this.watchBruciatoriChanges();
                            // Enable fields if we're adding a new element, else disable form
                            if (_this.form && _this.activeItem
                                && (!_this.formActiveSubitemId || _this.activeItem.key === "anagrafica")
                                && _this.mappaturaOpen) {
                                _this.options.formState = {
                                    disabled: false
                                };
                                _this.formBtnOptions.disabled = false;
                                _this.enableFormModify = true;
                                // Check new element and remake plant, then
                                // get save docs to import in new plant
                                if (_this.formActiveSection && !_this.formActiveSubitemId) {
                                    _this.remakePlantDocs = _this.condoStructuresService.getRemakeStrucutureDocs();
                                    // Check if same plant then remake plant.
                                    if (_this.remakePlantDocs
                                        && _this.remakePlantDocs.activeSection &&
                                        _this.remakePlantDocs.activeSection === _this.formActiveSection) {
                                        _this.remakePlant = true;
                                    }
                                    else {
                                        _this.remakePlant = false;
                                        _this.condoStructuresService.setRemakeStrucutureDocs("", "", {});
                                    }
                                }
                                if (typeof _this.model.files === "undefined") {
                                    _this.model["files"] = [];
                                }
                            }
                            else if (_this.form && _this.formActiveSubitemId) {
                                _this.options.formState = {
                                    disabled: true
                                };
                                _this.formBtnOptions.disabled = true;
                                _this.enableFormModify = false;
                            }
                        }
                    }
                }));
            }
            else {
                this.updateFormSection();
                this.cardIsLoading = false;
            }
            // @OLD
            // this.updateFormSection();
        }
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    AdminQRCodeMappingComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.onDestroy$.next();
        this.onDestroy$.complete();
    };
    /**
     * Init components
     *
     * @since 1.0.0
     */
    /**
     * Listen on form values changes
     *
     * @since 1.0.0
     */
    AdminQRCodeMappingComponent.prototype.watchFormChanges = function () {
        var _this = this;
        this.subscriptions.push(this.form.valueChanges.subscribe(function (res) {
            if (res && JSON.stringify(res) === _this.previousFormValue) {
                return;
            }
            else {
                _this.previousFormValue = JSON.stringify(res);
                if (_this.enableFormModify) {
                    _this.options.formState = {
                        disabled: false,
                    };
                    _this.form.updateValueAndValidity();
                }
                return;
            }
        }));
    };
    /**
     * Listen on input values changes
     *
     * @since 1.0.0
     */
    AdminQRCodeMappingComponent.prototype.watchScaleChanges = function () {
        var _this = this;
        this.mappingIndex = this.mappingIndex.map(function (item) {
            // Our goal here is to add a event listener to the item we are searching for
            if (item.title === "properties.structures.strutture" &&
                Array.isArray(item.content)) {
                item.content.map(function (subItem) {
                    if (subItem.key === "fabbricatoAbitativo" &&
                        subItem.formConfig &&
                        subItem.formConfig.length &&
                        subItem.formConfig[0].fieldGroup) {
                        var field = subItem.formConfig[0].fieldGroup.find(function (el) { return el.key === "nscale"; });
                        if (field) {
                            field.hooks = {
                                onInit: function (field) {
                                    field.formControl.valueChanges
                                        .pipe(takeUntil(_this.onDestroy$), startWith(field.formControl.value), tap(function (value) {
                                        if (typeof value === "undefined") {
                                            value = null;
                                        }
                                        if (value > field.templateOptions.max) {
                                            value = field.templateOptions.max;
                                        }
                                        if (_this.model.scale) {
                                            _this.model.scale.length = value;
                                        }
                                        _this.model = tslib_1.__assign({}, _this.model, { nscale: value });
                                    }))
                                        .subscribe();
                                }
                            };
                        }
                    }
                    return subItem;
                });
            }
            return item;
        });
    };
    /**
     * Listen on input values changes
     *
     * @since 1.0.0
     */
    AdminQRCodeMappingComponent.prototype.watchBruciatoriChanges = function () {
        var _this = this;
        this.mappingIndex = this.mappingIndex.map(function (item) {
            // Our goal here is to add a event listener to the item we are searching for
            if (item.title === "properties.structures.riscaldamentoCondizionamento" &&
                Array.isArray(item.content)) {
                item.content.map(function (subItem) {
                    if (subItem.key === "centraleTermica" &&
                        subItem.formConfig &&
                        subItem.formConfig.length &&
                        subItem.formConfig[0].fieldGroup) {
                        var field = subItem.formConfig[0].fieldGroup.find(function (el) { return el.key === "numeroBruciatori"; });
                        if (field) {
                            field.hooks = {
                                onInit: function (field) {
                                    field.formControl.valueChanges
                                        .pipe(takeUntil(_this.onDestroy$), startWith(field.formControl.value), tap(function (value) {
                                        if (typeof value === "undefined") {
                                            value = null;
                                        }
                                        if (value > field.templateOptions.max) {
                                            value = field.templateOptions.max;
                                        }
                                        _this.model.bruciatori.length = value;
                                        _this.model = tslib_1.__assign({}, _this.model, { numeroBruciatori: value });
                                    }))
                                        .subscribe();
                                }
                            };
                        }
                    }
                    return subItem;
                });
            }
            return item;
        });
    };
    /**
     * Translate all keys with given labels inside given object and returns it
     *
     * @since 4.0.0
     */
    AdminQRCodeMappingComponent.prototype.translateKeys = function (keys, obj) {
        var _this = this;
        if (Array.isArray(obj)) {
            obj.forEach(function (item) {
                for (var prop in item) {
                    if (item.hasOwnProperty(prop)) {
                        if (keys.includes(prop)) {
                            item[prop] = _this.translateService.instant(item[prop]);
                        }
                        if (typeof item[prop] === "object") {
                            item[prop] = _this.translateKeys(keys, item[prop]);
                        }
                    }
                }
            });
        }
        else {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    if (keys.includes(prop) && obj[prop]) {
                        obj[prop] = this.translateService.instant(obj[prop]);
                    }
                    if (typeof obj[prop] === "object") {
                        obj[prop] = this.translateKeys(keys, obj[prop]);
                    }
                }
            }
        }
        return obj;
    };
    // @NEW
    // hooks: {
    //   onInit(field: any) {
    //     field.defaultValue = `Scala ${+field.parent.key + 1}`; // formArray index + 1
    //   },
    // },
    // hooks: {
    //   onInit(field: any) {
    //     field.defaultValue = `Bruciatore ${
    //       +field.parent.key + 1
    //     }`; // formArray index + 1
    //   },
    // },
    AdminQRCodeMappingComponent.prototype.translateKeys2 = function (keys, obj) {
        var _this = this;
        if (Array.isArray(obj)) {
            obj.forEach(function (item) {
                var _loop_1 = function (prop) {
                    // hooks: 
                    // 1) numerazione progressiva all'aggiunta delle scale del Fabbricato abitativo
                    // 2) numerazione progressiva all'aggiunta dei bruciatori di Centrale termica
                    if (prop === "hooks") {
                        var propKey_1 = item[prop];
                        item[prop] = {
                            onInit: function (field) {
                                field.defaultValue = propKey_1 + " " + (+field.parent.key + 1);
                            },
                        };
                    }
                    // hideExpression: 
                    // nasconde il corrente campo se il valore del campo indicato soddisfa i criteri indicati da "operator"
                    // e diabilita l'obbligatorietà del campo in "templateOptions.required"
                    if (prop === "hideExpression" && item[prop]) {
                        var propKey_2 = item[prop].key;
                        var propCompareValue_1 = item[prop].value;
                        if (item[prop].operator === "!==") {
                            item[prop] = function (model, formState, field) {
                                var key = propKey_2;
                                var currentValue = model[key];
                                var compareValue = propCompareValue_1;
                                return currentValue !== compareValue;
                            };
                        }
                        else if (item[prop].operator === "!") {
                            item[prop] = function (model, formState, field) {
                                var key = propKey_2;
                                var currentValue = model[key];
                                return !currentValue;
                            };
                        }
                        else if (item[prop].operator === "!includes") {
                            item[prop] = function (model, formState, field) {
                                var key = propKey_2;
                                var currentValue = model[key];
                                var compareValue = propCompareValue_1;
                                return typeof currentValue === "undefined" || !currentValue.includes(compareValue);
                            };
                        }
                    }
                    // expressionProperties:
                    // Contatore energia elettrica:
                    // disabilita il campo "connessioni" e/o "alimenta un singolo impianto" 
                    // usato in "templateOptions.disabled"
                    if (prop === "expressionProperties" && item[prop]) {
                        var propDisabled = item[prop].disabled;
                        if (propDisabled !== "formState.disabled" &&
                            propDisabled !== "connessioni" &&
                            propDisabled !== "") {
                            var key_1 = propDisabled;
                            propDisabled = function (model, formState, field) {
                                return model[key_1] || formState.disabled;
                            };
                        }
                        else if (propDisabled === "connessioni") {
                            var key_2 = propDisabled;
                            propDisabled = function (model, formState, field) {
                                if (model[key_2] === "undefined") {
                                    return false;
                                }
                                else if (Array.isArray(model[key_2]) && model[key_2].length > 0) {
                                    return true;
                                }
                                return false;
                            };
                        }
                        if (typeof item[prop].required !== "undefined") {
                            var propKey_3 = item[prop].required.key;
                            var propCompareValue_2 = item[prop].required.value;
                            if (item[prop].required.operator === "===") {
                                item[prop] = {
                                    "templateOptions.disabled": propDisabled,
                                    "templateOptions.required": function (model, formState, field) {
                                        var key = propKey_3;
                                        var currentValue = model[key];
                                        var compareValue = propCompareValue_2;
                                        return currentValue === compareValue;
                                    }
                                };
                            }
                            else if (item[prop].required.operator === "!") {
                                item[prop] = {
                                    "templateOptions.disabled": propDisabled,
                                    "templateOptions.required": function (model, formState, field) {
                                        var key = propKey_3;
                                        var currentValue = model[key];
                                        return !currentValue;
                                    }
                                };
                            }
                            else if (item[prop].required.operator === "") {
                                item[prop] = {
                                    "templateOptions.disabled": propDisabled,
                                    "templateOptions.required": function (model, formState, field) {
                                        var key = propKey_3;
                                        var currentValue = model[key];
                                        return currentValue;
                                    }
                                };
                            }
                        }
                        else {
                            item[prop] = {
                                "templateOptions.disabled": propDisabled,
                            };
                        }
                    }
                    // defaultValue:
                    // contiene il valore predefinito del campo corrente
                    if (prop === "defaultValue" && item[prop]) {
                        if (item[prop] === "false") {
                            item[prop] = false;
                        }
                        else if (item[prop] === "true") {
                            item[prop] = true;
                        }
                    }
                    // wrappers:
                    // struttura del titolo/campo nel form: orizzontale/verticale  
                    // oppure in assenza di "key" e in presenza di "template" => visualizza contenuto di "template"
                    if (prop === "wrappers" && item[prop] && Array.isArray(item[prop]) && item[prop].length === 0) {
                        item[prop] = "";
                    }
                    if (item.hasOwnProperty(prop)) {
                        if (keys.includes(prop)) {
                            if (item["translation"]) {
                                item[prop] = item["translation"].it;
                            }
                        }
                        if (typeof item[prop] === "object") {
                            item[prop] = _this.translateKeys2(keys, item[prop]);
                        }
                    }
                };
                for (var prop in item) {
                    _loop_1(prop);
                }
            });
        }
        else {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    // options:
                    // in "templateOptions" e
                    // contiene l'elenco dei valori del campo di tipo select (value/translation)
                    if (prop === "options" && Array.isArray(obj[prop])) {
                        obj[prop].forEach(function (elem) {
                            if (elem.value && elem.value === "true") {
                                elem.value = true;
                            }
                            else if (elem.value && elem.value === "false") {
                                elem.value = false;
                            }
                        });
                    }
                    if (keys.includes(prop) && obj[prop]) {
                        obj[prop] = this.translateService.instant(obj[prop]);
                        if (prop === "label" && obj["translationLabel"]) {
                            obj[prop] = obj["translationLabel"].it;
                        }
                        else if (prop === "placeholder" && obj["translationPlaceholder"]) {
                            obj[prop] = obj["translationPlaceholder"].it;
                        }
                    }
                    if (typeof obj[prop] === "object") {
                        obj[prop] = this.translateKeys2(keys, obj[prop]);
                    }
                }
            }
        }
        return obj;
    };
    /**
     * Get children (existing values) for requested section
     *
     * @since 1.0.0
     */
    AdminQRCodeMappingComponent.prototype.getChildren = function (key) {
        if (typeof this.condoStructure !== "undefined"
            && typeof this.condoStructure[key] !== "undefined") {
            if (key === "anagrafica") {
                return [];
            }
            else {
                if (Array.isArray(this.condoStructure[key])) {
                    var structures = JSON.parse(JSON.stringify(this.condoStructure[key]));
                    structures = structures.filter(function (el) { return el.active; });
                    return structures;
                }
                else {
                    return [];
                }
            }
        }
        return [];
    };
    /**
     * Update form section depending on route params
     *
     * @since 1.0.0
     */
    AdminQRCodeMappingComponent.prototype.updateFormSection = function () {
        var _this = this;
        // Reset model to prevent import previous form data
        if (this.model) {
            for (var property in this.model) {
                delete this.model[property];
            }
        }
        var target = document.getElementById("sideMenu");
        var top = target.offsetHeight;
        window.scrollTo({
            top: top,
            behavior: "smooth",
        });
        // Reset data and call the new data form
        if (this.form) {
            this.options.formState = {
                disabled: true
            };
        }
        // Add section param to routing, which is used in connections type
        var params = Object.assign({}, this.activatedRoute.snapshot.params, { selected: false });
        params.mappingFormActiveSection = this.formActiveSection;
        this.activatedRoute.snapshot.params = params;
        if (this.formActiveSection) {
            this.formIsLoading = true; // Start form loading
            // BEGIN - Set open status to current mapping index
            var origFormActiveSection_1 = this.formActiveSection.replace(this.property.structure, ":structureId");
            this.mappingIndex.map(function (item) {
                item.content.map(function (subItem) {
                    if (subItem.section === origFormActiveSection_1) {
                        // Get currente element is a Plant
                        // delete note field from form
                        // if (subItem.formConfig
                        //   && Array.isArray(subItem.formConfig)
                        //   && subItem.formConfig.length) {
                        //   if (subItem.formConfig[0].fieldGroup
                        //     && Array.isArray(subItem.formConfig[0].fieldGroup)
                        //     && subItem.formConfig[0].fieldGroup.length) {
                        //     const index = subItem.formConfig[0].fieldGroup.findIndex((el: any) => {
                        //       return el.key === "note";
                        //     })
                        //     if (index > -1) {
                        //       subItem.formConfig[0].fieldGroup.splice(index, 1);
                        //     }
                        //   }
                        // }
                        if (item.title === "properties.structures.impiantiElettrici" ||
                            item.title === "properties.structures.trattamentoAcqua" ||
                            item.title ===
                                "properties.structures.riscaldamentoCondizionamento" ||
                            item.title === "properties.structures.dispositiviAntincendio" ||
                            item.title === "properties.structures.ascensoriEMontauto" ||
                            item.title === "properties.structures.impiantiElettronici" ||
                            item.title === "properties.structures.lineeVita" ||
                            item.title === "properties.structures.impiantiSpeciali" ||
                            item.title === "properties.structures.impiantiRicreativi") {
                            _this.sectionPlant = true;
                        }
                        else {
                            _this.sectionPlant = false;
                        }
                        item.expanded = true;
                        subItem.expanded = true;
                        subItem.active = true;
                        _this.activeItem = subItem;
                        if (_this.formActiveSection &&
                            origFormActiveSection_1 !==
                                "condo-structures/:structureId/anagrafica") {
                            var children = _this.getChildren(subItem.key);
                            if (children.length) {
                                _this.activeSubitem = children.find(function (val) { return val._id === _this.formActiveSubitemId; });
                                if (_this.activeSubitem && _this.activeSubitem.files) {
                                    if (_this.form.controls.files) {
                                        _this.form.controls.files.setValue(_this.activeSubitem.files);
                                    }
                                    _this.form.updateValueAndValidity();
                                }
                                if (_this.activeSubitem && _this.activeSubitem.note) {
                                    _this.existingNotes = _this.activeSubitem.note;
                                    _this.activeSubitem.note = null;
                                }
                                _this.fields = subItem.formConfig;
                                if (_this.activeSubitem) {
                                    _this.model = _this.activeSubitem;
                                }
                                else {
                                    // Add new subitem. Default name from section
                                    var tot = children.length + 1;
                                    var nome = subItem.translation.it + " " + tot;
                                    // this.translateService.instant(subItem.title) + " " + tot;
                                    _this.model = { nome: nome, files: [], };
                                    // Delete defaultValue from field Files, to clear previous upload image
                                    if (subItem.formConfig
                                        && Array.isArray(subItem.formConfig)
                                        && subItem.formConfig.length) {
                                        if (subItem.formConfig[0].fieldGroup
                                            && Array.isArray(subItem.formConfig[0].fieldGroup)
                                            && subItem.formConfig[0].fieldGroup.length) {
                                            var index = subItem.formConfig[0].fieldGroup.findIndex(function (el) {
                                                return el.key === "files";
                                            });
                                            if (index > -1) {
                                                if (subItem.formConfig[0].fieldGroup[index].templateOptions
                                                    && Array.isArray(subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue)
                                                    && subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue.length) {
                                                    subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue = [];
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                if (_this.activeSubitem && _this.activeSubitem.note) {
                                    _this.existingNotes = _this.activeSubitem.note;
                                    _this.activeSubitem.note = null;
                                }
                                // New first subitem. Default name from section
                                _this.fields = subItem.formConfig;
                                var nome = subItem.translation.it + " 1";
                                // this.translateService.instant(subItem.title) + " 1";
                                _this.model = { nome: nome, files: [], };
                                // Delete defaultValue from field Files, to clear previous upload image
                                if (subItem.formConfig
                                    && Array.isArray(subItem.formConfig)
                                    && subItem.formConfig.length) {
                                    if (subItem.formConfig[0].fieldGroup
                                        && Array.isArray(subItem.formConfig[0].fieldGroup)
                                        && subItem.formConfig[0].fieldGroup.length) {
                                        var index = subItem.formConfig[0].fieldGroup.findIndex(function (el) {
                                            return el.key === "files";
                                        });
                                        if (index > -1) {
                                            if (subItem.formConfig[0].fieldGroup[index].templateOptions
                                                && Array.isArray(subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue)
                                                && subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue.length) {
                                                subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue = [];
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else if (subItem.section === "condo-structures/:structureId/anagrafica") {
                            _this.activeSubitem = _this.condoStructure.anagrafica;
                            // Anagrafica: is not completed
                            if (typeof _this.activeSubitem === "undefined") {
                                _this.activeSubitem = {
                                    active: true
                                };
                            }
                            if (_this.activeSubitem && _this.activeSubitem.note) {
                                _this.existingNotes = _this.activeSubitem.note;
                                _this.activeSubitem.note = null;
                            }
                            _this.fields = subItem.formConfig;
                            _this.model = _this.activeSubitem;
                            _this.formActiveSubitemId = Math.random().toString();
                        }
                    }
                    else {
                        subItem.active = false;
                    }
                });
            });
            if (this.form && !this.condoStructure.open) {
                this.options.formState = {
                    disabled: true
                };
            }
            // END - Set open status to current mapping index
            setTimeout(function () {
                _this.formIsLoading = false;
            }, 300);
        }
        else {
            // Reset the last item.expanded mappingIndex to close tree from previous structure
            if (Array.isArray(this.mappingIndex) && this.mappingIndex.length) {
                this.mappingIndex.forEach(function (item) {
                    if (item.expanded) {
                        item.expanded = false;
                        if (Array.isArray(item.content) && item.content.length) {
                            item.content.forEach(function (elem) {
                                if (elem.active) {
                                    elem.active = false;
                                }
                            });
                        }
                    }
                });
            }
        }
    };
    /**
     * Navigate to given section inside the same property detail page
     *
     * @since 1.0.0
     */
    AdminQRCodeMappingComponent.prototype.activateSection = function (rawSection) {
        var target = document.getElementById("sideMenu");
        var top = target.offsetHeight;
        window.scrollTo({
            top: top,
            behavior: "smooth",
        });
        // Return if we're trying to navigate to 'anagrafica' but
        // we're already in that route
        if (rawSection.endsWith('anagrafica')) {
            if (this.activatedRoute.snapshot.params.mappingFormActiveSection
                && this.activatedRoute.snapshot.params.mappingFormActiveSection.endsWith('anagrafica')) {
                return;
            }
        }
        // Reset data and call the new data form
        this.formActiveSubitemId = undefined;
        var controls = this.form.controls;
        for (var key in controls) {
            this.form.removeControl(key);
        }
        var section = rawSection.replace(":structureId", this.property.structure);
        this.formActiveSubitemId = "";
        this.formActiveSection = section;
        // this.router.navigate(
        //   [this.lang, "app", "properties", this.property._id, "mapping", section],
        //   {
        //     replaceUrl: true,
        //     // queryParams: { refresh: new Date().getTime() }
        //   }
        // );
        this.updateFormSection();
    };
    /**
     * Handle panel header open/close
     *
     * @since 1.0.0
     *
     */
    AdminQRCodeMappingComponent.prototype.onPanelClicked = function (item, index) {
        item.expanded = !item.expanded;
        this.mappingIndex.forEach(function (el, i) {
            if (i !== index) {
                el.expanded = false;
            }
        });
        // Handle scroll to panel
        if (item.expanded) {
            var headerHeight = 60;
            var top_1 = (headerHeight * (index + 1)) - headerHeight;
            window.scrollTo({
                top: top_1,
                behavior: "smooth"
            });
        }
    };
    /**
     * Handle form item click and open view/edit popup
     *
     * @since 1.0.0
     */
    AdminQRCodeMappingComponent.prototype.onFormItemClick = function (rawSection, item) {
        var target = document.getElementById("sideMenu");
        var top = target.offsetHeight;
        window.scrollTo({
            top: top,
            behavior: "smooth",
        });
        var itemId = "";
        if (item && item._id) {
            itemId = item._id;
        }
        var section = rawSection.replace(":structureId", this.property.structure);
        if (rawSection !== 'condo-structures/:structureId/anagrafica') {
            this.enableFormModify = false;
        }
        this.formActiveSubitemId = item._id;
        this.formActiveSection = section;
        this.updateFormSection();
    };
    /**
     * Check if given macr-section item is visibile or not depending on
     * structure open status. If structure is open, than this will always returns true
     * If it's false, this will check if at least one sub-section has one or more
     * values. If so, return true, otherwise return false;
     *
     * @since 1.0.0
     */
    AdminQRCodeMappingComponent.prototype.checkVisibility = function (item) {
        var _this = this;
        if (!this.mappaturaOpen) {
            if (item.content && item.content.length) {
                // Let's make anagrafica section ALWAYS visible
                if (item.content[0].key === "anagrafica") {
                    return true;
                }
                return item.content.some(function (subitem) { return _this.getChildren(subitem.key).length; });
            }
            return false;
        }
        return true;
    };
    /**
     * Open note dialog
     *
     * @since 1.0.0
     */
    AdminQRCodeMappingComponent.prototype.onNoteDialog = function () {
        var dialogRef = this.dialog.open(PropertyDetailMappingNoteDialogComponent, {
            data: {
                modalTitle: this.translateService.instant("properties.structures.notes"),
                existingNotes: this.existingNotes,
                condoStructureId: this.condoStructure._id,
                structureId: this.model._id,
                structureName: this.model.nome,
            },
            width: "500px"
        });
    };
    /**
     * Handle click to show document notes
     *
     * @since 1.0.0
     */
    AdminQRCodeMappingComponent.prototype.onViewDocumentNotes = function () {
        var note = [];
        if (this.condoStructure) {
            var _loop_2 = function (key) {
                var e_2, _a, e_3, _b;
                if (Array.isArray(this_1.condoStructure[key]) &&
                    this_1.condoStructure[key].length) {
                    var structureTranslated_1 = '';
                    var find = false;
                    var structureTemplate = JSON.parse(JSON.stringify(this_1.condoStructureTemplate));
                    if (structureTemplate && Array.isArray(structureTemplate)) {
                        try {
                            for (var structureTemplate_1 = (e_2 = void 0, tslib_1.__values(structureTemplate)), structureTemplate_1_1 = structureTemplate_1.next(); !structureTemplate_1_1.done; structureTemplate_1_1 = structureTemplate_1.next()) {
                                var level1 = structureTemplate_1_1.value;
                                if (level1.content && Array.isArray(level1.content)) {
                                    try {
                                        for (var _c = (e_3 = void 0, tslib_1.__values(level1.content)), _d = _c.next(); !_d.done; _d = _c.next()) {
                                            var level2 = _d.value;
                                            // if (level2.title === `properties.structures.${key}`) {
                                            if (level2.key === key) {
                                                structureTranslated_1 = level2.translation[this_1.lang];
                                                find = true;
                                                break;
                                            }
                                        }
                                    }
                                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                    finally {
                                        try {
                                            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                                        }
                                        finally { if (e_3) throw e_3.error; }
                                    }
                                }
                                if (find) {
                                    break;
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (structureTemplate_1_1 && !structureTemplate_1_1.done && (_a = structureTemplate_1.return)) _a.call(structureTemplate_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                    }
                    this_1.condoStructure[key].forEach(function (el, index) {
                        if (el.active && el.note && Array.isArray(el.note) && el.note.length) {
                            el.note.forEach(function (subEl, indexNote) {
                                note.push({
                                    createdAt: subEl.createdAt,
                                    createdBy: subEl.createdBy.firstName + " " + subEl.createdBy.lastName,
                                    text: subEl.text,
                                    name: el.nome ? el.nome : "",
                                    // structure: this.translateService.instant(
                                    //   "properties.structures." + key
                                    // ),
                                    structure: structureTranslated_1,
                                    structureName: key,
                                    structurePosition: index,
                                    structureId: el._id,
                                    notePosition: indexNote,
                                    noteId: subEl._id,
                                });
                            });
                        }
                    });
                }
            };
            var this_1 = this;
            for (var key in this.condoStructure) {
                _loop_2(key);
            }
        }
        var noteDialogRef = this.dialog.open(PropertyDetailDocumentNoteDialogComponent, {
            data: {
                modalTitle: this.translateService.instant("properties.documentsPage.noteList"),
                condoStructureId: this.condoStructure._id,
                notes: note,
            },
            minWidth: "50%",
        });
    };
    return AdminQRCodeMappingComponent;
}());
export { AdminQRCodeMappingComponent };
